<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <ul id="unitoverhisTab" class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button id="first-unitoverhis" class="nav-link" data-bs-toggle="tab" data-bs-target="#firstUnitoverHis"
              type="button" role="tab" aria-controls="firstUnitoverHis" @click="onClickTab('1')">
              {{ $t("content.amnunitoverhis") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button id="second-unitoverhis" class="nav-link" data-bs-toggle="tab" data-bs-target="#secondUnitoverHis"
              type="button" role="tab" aria-controls="secondUnitoverHis" @click="onClickTab('2')">
              {{ $t("content.amnunitoverlot") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button id="third-unitoverhis" class="nav-link" data-bs-toggle="tab" data-bs-target="#thirdUnitoverHis"
              type="button" role="tab" aria-controls="thirdUnitoverHis" :disabled="lurc_search === ''"
              @click="onClickTab('3')">
              {{ $t("content.amnunitovermng") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button id="fourth-unitoverhis" class="nav-link" data-bs-toggle="tab" data-bs-target="#fourthUnitoverHis"
              type="button" role="tab" aria-controls="fourthUnitoverHis" @click="onClickTab('4')">
              {{ $t("content.amnunitoversav") }}
            </button>
          </li>
        </ul>

        <div id="unitoverhisTabContent" class="tab-content">
          <div id="firstUnitoverHis" class="tab-pane fade" role="tabpanel" aria-labelledby="first-unitoverhis">
            <div class="card h-100 mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.amnunitoverhis") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-2 mt-1">
                    <label class="form-label ms-0">{{ $t("content.sdate") }}</label>
                    <VueDatePicker v-model="start_hdate" :format="format" auto-apply :teleport="true"
                      :max-date="new Date()" :enable-time-picker="true" month-name-format="long" :clearable="false"
                      :text-input="textInputOptions" fluid />
                  </div>

                  <div class="col-lg-2 mt-1">
                    <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                    <VueDatePicker v-model="end_hdate" :format="format" auto-apply :teleport="true"
                      :max-date="new Date()" :enable-time-picker="true" month-name-format="long" :clearable="false"
                      :text-input="textInputOptions" fluid />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{
                      $t("content.amnassetgroup")
                    }}</label>
                    <select v-model="cat_hsearch" class="form-select">
                      <option value="">{{ $t("content.optall") }}</option>
                      <option v-for="(index) in listcat_order" :key="index" :data-id="index" :value="index">
                        <span v-if="listprint.length > 0 && listcat_order.length > 0">
                          {{ filterCat(index) }}
                        </span>
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t("content.names") }}</label>
                    <div class="input-group">
                      <input v-model="cusName_search" type="text" class="form-control" aria-describedby="searchName"
                        readonly />
                      <button class="btn btn-primary" type="button" @click="openDialogCus">
                        <i class="material-icons material-symbols-outlined">search</i>
                      </button>
                      <button id="searchNameCus" class="btn btn-primary" type="button" data-bs-toggle="modal"
                        data-bs-target="#searchNameModal" v-show="false">
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                    <material-input id="ticketno" type="text" v-model="tk_hsearch" />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.stockno") }}</label>
                    <material-input id="stockno" type="text" v-model="stock_hsearch" />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.lotno") }}</label>
                    <material-input id="lotno" type="text" v-model="lot_hsearch" />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.status") }}</label>
                    <select v-model="status_hsearch" class="form-select">
                      <option v-for="(a, sta) in list_odstatus" :key="sta" :value="a.value">
                        {{ a.items }}
                      </option>
                    </select>
                  </div>




                  <div class="col-auto">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cardSearch" color="primary" class="mb-3" :disabled="start_hdate > end_hdate"
                      @click="loadHistoryListApi">
                      <i class="material-icons material-symbols-outlined">search</i>
                      {{ $t("buttons.sear") }}
                    </material-button>
                  </div>
                  <div class="col-auto">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cancSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                      @click="cancelHistoryBtn">
                      <i class="material-icons material-symbols-outlined">close</i>
                      {{ $t("buttons.canc") }}
                    </material-button>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.names") }}</th>
                          <th>{{ $t("content.ticketno") }}</th>
                          <th>{{ $t("content.stockno") }}</th>
                          <th>{{ $t("content.lotno") }}</th>
                          <th>{{ $t("content.amnassetgroup") }}</th>
                          <th>{{ $t("content.allweight") }}</th>
                          <th>{{ $t("content.allqty") }}</th>
                          <th>{{ $t("content.amnpawnvalall") }}</th>
                          <th>{{ $t("content.status") }}</th>
                          <th>{{ $t("content.amnmaker") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listhis" :key="index">
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberString((currentPageH - 1) * perPageH + index + 1) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ format_datetime(row.createDate) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.cusName }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.tkRefNumber }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.stockNumber }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.lotNumber }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ row.catName }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.weight) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberString(row.quantity) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.pawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ filterODStatus(row.action) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.userName }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              :title="t('buttons.seed')" @click="openDetail(row)">
                              <i class="material-icons material-symbols-outlined">visibility</i>
                            </material-button>
                            <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#lookupModal2" id="detailModal">
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listhis.length === 0">
                          <td colspan="11" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="13" style="text-align: right">Total Rows : {{ totalRows_sH }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listhis.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageH" :total-items="totalRowsH"
                          :items-per-page="perPageH" @click="onClickHandlerH" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div id="secondUnitoverHis" class="tab-pane fade" role="tabpanel" aria-labelledby="second-unitoverhis">
            <div class="card h-100 mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.amnunitoverlot") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                   <div class="col-lg-2  mt-0">
                    <fieldset>
                      <div class="item">
                        <material-checkbox v-model="time" :checked="time" name="autoSelect" @change="onserachDate">
                          <label class="form-label m-0">{{ $t("content.msdate") }}</label>
                        </material-checkbox>
                        <VueDatePicker v-model="start_month" :format="format_month" auto-apply :teleport="true"
                          :max-date="max_month" month-picker :clearable="false" fluid :disabled="!time"
                          :text-input="textInputOptions_month" />
                      </div>
                    </fieldset>
                  </div>
                  
                  <div class="col-lg-2 mt-2">
                      <label class="form-label ms-0">{{ $t("content.medate") }}</label>
                      <VueDatePicker v-model="end_month" :format="format_month" auto-apply :teleport="true"
                        :max-date="max_month"  month-picker
                        :clearable="false" fluid :disabled="!time" :text-input="textInputOptions_month" />
                  </div>

                  <div class="col-lg-3 mt-2">
                    <label class="form-label ms-0">{{ $t("content.lotno") }}</label>
                    <material-input v-model="lot_search" id="lotno" type="text" />
                  </div>

                  <div class="col-lg-2 mt-2">
                    <label class="form-label ms-0">{{ $t("content.status") }}</label>
                    <select v-model="status_search" class="form-select">
                      <option v-for="(a, sta) in list_odstatus" :key="sta" :value="a.value">
                        {{ a.items }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-2 mt-2">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                      :disabled="(time && new Date(start_month.year, start_month.month) > new Date(end_month.year, end_month.month))" @click="loadBreakingListApi">
                      <i class="material-icons material-symbols-outlined">search</i>
                      {{ btnSearch }}
                    </material-button>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.lotno") }}</th>
                          <th class="text-center">{{ $t("content.amnticall") }}</th>
                          <th class="text-center">{{ $t("content.amnallitem") }}</th>
                          <th class="text-center">
                            {{ $t("content.capprice") }}
                          </th>
                          <th class="text-center">
                            {{ $t("content.approxprice") }}
                          </th>
                          <th class="text-center">
                            {{ $t("content.sellprice") }}
                          </th>
                          <th class="text-center">
                            {{ $t("content.amnresults") }}
                          </th>
                          <th class="text-center">{{ $t("content.status") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>

                        <tr v-for="(row, index) in listbk" :key="index">
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberString((currentPageB - 1) * perPageB + index + 1) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ format_datetime(row.createDate) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.lotNumber }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberString(row.numOfTicket) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberString(row.quantity) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.pawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.estimatePrice) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.salePrice) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            <span v-if="row.profitLoss > 0" style="color:green;">
                              {{ formatNumberDecimalString(row.profitLoss) }}
                            </span>
                            <span v-else-if="row.profitLoss < 0" style="color:red;">
                              {{ formatNumberDecimalString(row.profitLoss) }}
                            </span>
                            <span v-else>
                              {{ formatNumberDecimalString(row.profitLoss) }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal  text-center">
                            {{ filterODStatus(row.status) }}
                          </td>

                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="bottom" :title="t('buttons.edit')"
                              :disabled="row.status !== 'SCAN_OUT' && row.status !== 'ESTIMATION_COMPLETE' && row.status !== 'COMPLETE'"
                              @click="setRecode(row)">
                              <i class=" material-icons material-symbols-outlined">edit</i>
                            </material-button>
                            <material-button color="success" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="bottom" title="Excel" @click="XlsxGen(row)">
                              <i class="material-icons material-symbols-outlined">table_rows</i>
                            </material-button>
                            <material-button color="warning" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="bottom" title="PDF" @click="pdfGen(row)">
                              <i class="material-icons material-symbols-outlined">picture_as_pdf</i>
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listbk.length === 0">
                          <td colspan="9" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="11" style="text-align: right">Total Rows : {{ totalRows_sB }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listbk.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageB" :total-items="totalRowsB"
                          :items-per-page="perPageB" @click="onClickHandlerBk" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div id="thirdUnitoverHis" class="tab-pane fade" role="tabpanel" aria-labelledby="third-unitoverhis">
            <div class="card h-100 mt-2">
              <div class="card-header mb-0">
                <div class="row no-gutters">
                  <div class="col-12 d-flex justify-content-between align-items-center">
                    <h5>{{ $t("content.amnunitovermng") }}</h5>
                    <div>
                      <material-button color="primary" class="float-lg-start float-sm-end mb-0" @click="getEstGoldInfo"
                        :disabled="catrc_search === '' || filterCat(catrc_search) !== 'ทอง' || listrc.length === 0 || filterStatuslistrc() || lotStatus === 'COMPLETE' || estEStatus">
                        <i class="material-icons material-symbols-outlined">summarize</i>
                        {{ $t("content.estGold") }}
                      </material-button>
                      <material-button id="estimateModal" color="info" variant="outline" class="rounded-circle"
                        data-bs-toggle="modal" data-bs-target="#estimateGoldManageModal" v-show="false">
                      </material-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{
                      $t("content.amnassetgroup")
                    }}</label>
                    <select v-model="catrc_search" class="form-select" @change="setlistrc">
                      <option value="">{{ $t("content.optall") }}</option>
                      <option v-for="(index) in listcat_order" :key="index" :data-id="index" :value="index">
                        <span v-if="listprint.length > 0 && listcat_order.length > 0">
                          {{ filterCat(index) }}
                        </span>
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t("content.lotno") }}</label>
                    <material-input id="lotno" type="text" v-model="lrc_search" disabled />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                      :disabled="lrc_search === ''" @click="loadRecodeListApi()">
                      <i class="material-icons material-symbols-outlined">search</i>
                      {{ btnSearch }}
                    </material-button>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>{{ $t("content.ticketno") }}</th>
                          <th>{{ $t("content.stockno") }}</th>
                          <th>{{ $t("content.amnassetgroup") }}</th>
                          <th class="text-center">{{ $t("content.allweight") }}</th>
                          <th class="text-center">{{ $t("content.allqty") }}</th>
                          <th class="text-center">{{ $t("content.amnpawnvalall") }}</th>
                          <th>{{ $t("content.status") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listrc" :key="index">
                          <td class="text-sm font-weight-normal">
                            {{ row.tkRefNumber }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.stockNumber }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ filterCat(row.catUid) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.weight) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberString(row.quantity) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.pawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ filterODStatus(row.status) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              :title="t('buttons.edit')" @click="setColl(row)"
                              :disabled="row.status === 'ACTIVE' || row.status === 'SCAN_IN'">
                              <i class="material-icons material-symbols-outlined">edit</i>
                            </material-button>
                            <material-button id="collateralModal" color="info" variant="outline" class="rounded-circle"
                              data-bs-toggle="modal" data-bs-target="#newUnitOverHistoryManageModal" v-show="false">
                            </material-button>
                            <material-button color="primary" variant="outline" class="rounded-circle"
                              @click="getworkCaseImg(row)">
                                <i class="material-icons material-symbols-outlined">photo_library</i>
                            </material-button>
                            <material-button color="warning" class="float-lg-start float-sm-end mb-3" data-bs-toggle="modal"
                                data-bs-target="#galleryModal" id="viewGallery" v-show="false">
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listrc.length === 0">
                          <td colspan="10" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="11" style="text-align: right">Total Rows : {{ totalRows_sRC }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listrc.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageRC" :total-items="totalRowsRC"
                          :items-per-page="perPageRC" @click="onClickHandlerRC" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div id="fourthUnitoverHis" class="tab-pane fade" role="tabpanel" aria-labelledby="fourth-unitoverhis">
            <div class="card h-100 mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.amnunitoversav") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-12">
                    <ul id="saveunitoverhisTab" class="nav nav-tabs" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button id="second-saveunitoverhis" class="nav-link" data-bs-toggle="tab"
                          data-bs-target="#secondSaveUnitoverHis" type="button" role="tab"
                          aria-controls="secondSaveUnitoverHis" @click="onClickSubTab('1')">
                          {{ $t("content.item") }}
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button id="third-saveunitoverhis" class="nav-link" data-bs-toggle="tab"
                          data-bs-target="#thirdSaveUnitoverHis" type="button" role="tab"
                          aria-controls="thirdSaveUnitoverHis" :disabled="rv_detail.uid === ''"
                          @click="onClickSubTab('2')">
                          {{ $t("content.act") }}
                        </button>
                      </li>
                    </ul>

                    <div id="saveunitoverhisTabContent" class="tab-content">
                      <div id="secondSaveUnitoverHis" class="tab-pane fade" role="tabpanel"
                        aria-labelledby="second-saveunitoverhis">
                        <div class="h-100 mt-2">
                          <div class="card-body pt-0 mt-5">
                            <div class="row">
                              <div class="col-lg-4">
                                <label class="form-label ms-0">{{
                                  $t("content.lotno")
                                }}</label>
                                <material-input id="lotno" type="text" v-model="lrvl_search" />
                              </div>

                              <div class="col-lg-2">
                                <label class="form-label ms-0 png"></label>
                                <material-button id="cardSearch" color="primary"
                                  class="float-lg-start float-sm-end mb-3" :disabled="lrvl_search === ''"
                                  @click="lotReturnList('search')">
                                  <i class="material-icons material-symbols-outlined">search</i>
                                  {{ btnSearch }}
                                </material-button>
                              </div>
                            </div>
                            <div class="row mt-3">
                              <div class="table-responsive">
                                <table class="table table-flush">
                                  <thead class="thead-light">
                                    <tr>
                                      <th>#</th>
                                      <th>{{ $t("content.dant") }}</th>
                                      <th>{{ $t("content.lotno") }}</th>
                                      <th class="text-center">
                                        {{ $t("content.amnticall") }}
                                      </th>
                                      <th class="text-center">
                                        {{ $t("content.amnallitem") }}
                                      </th>
                                      <th>{{ $t("content.act") }}</th>
                                    </tr>
                                  </thead>
                                  <tbody>

                                    <tr v-for="(row, index) in listrvl" :key="index">
                                      <td class="text-sm font-weight-normal">
                                        {{ formatNumberString((currentPageR - 1) * perPageR + index + 1) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ format_datetime(row.createDate) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ row.lotNumber }}
                                      </td>
                                      <td class="text-sm font-weight-normal text-center">
                                        {{ formatNumberString(row.numOfTicket) }}
                                      </td>
                                      <td class="text-sm font-weight-normal text-center">
                                        {{ formatNumberString(row.quantity) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        <material-button color="info" variant="outline" class="rounded-circle"
                                          data-bs-toggle="tooltip" data-bs-placement="bottom" :title="t('buttons.edit')"
                                          @click="setRv(row)" :disabled="row.status !== 'ESTIMATION_COMPLETE'">
                                          <i class="material-icons material-symbols-outlined">edit</i>
                                        </material-button>
                                      </td>
                                    </tr>
                                    <tr v-if="listrvl.length === 0">
                                      <td colspan="10" class="text-sm font-weight-normal">
                                        <p style="text-align: center">No Record Found</p>
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td colspan="11" style="text-align: right">Total Rows : {{ totalRows_sLR }}</td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                            <pre></pre>
                            <div style="display: flex; justify-content: flex-end">
                              <ul v-show="listrvl.length > 0" class="pagination justify-content-end">
                                <div class="project-container">
                                  <div class="example-one">
                                    <vue-awesome-paginate v-model="currentPageLR" :total-items="totalRowsLR"
                                      :items-per-page="perPageLR" @click="onClickHandlerLR" />
                                  </div>
                                </div>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div id="thirdSaveUnitoverHis" class="tab-pane fade" role="tabpanel"
                        aria-labelledby="third-saveunitoverhis">
                        <div class="h-100 mt-2" style='overflow:hidden'>
                          <div class="card-body pt-0 mt-5">
                            <div class="row">
                              <div class="col-lg-2 col-md-6">
                                <label class="form-label ms-0">{{
                                  $t("content.lotno")
                                }}</label>
                                <material-input id="lotno" type="text" v-model="rv_detail.lotNo" disabled />
                              </div>

                              <div class="col-lg-2 col-md-6">
                                <label class="form-label ms-0">{{
                                  $t("content.amnticall")
                                }}</label>
                                <material-input id="lotno" type="text" v-model="rv_detail.numOfTicket_s" disabled />
                              </div>

                              <div class="col-lg-2 col-md-6">
                                <label class="form-label ms-0">{{
                                  $t("content.amnallitem")
                                }}</label>
                                <material-input id="lotno" type="text" v-model="rv_detail.quantity_s" disabled />
                              </div>

                              <div class="col-lg-2 col-md-6">
                                <label class="form-label ms-0">{{
                                  $t("content.cappriceall")
                                }}</label>
                                <material-input id="lotno" type="text" v-model="rv_detail.pawnValue_s" disabled />
                              </div>

                              <div class="col-lg-2 col-md-6">
                                <label class="form-label ms-0 png"></label>
                                <material-button id="cardSearch" color="primary"
                                  class="float-lg-start float-sm-end mb-3"
                                  :disabled="rv_detail.closed || listrv.length === 0" @click="completeLot">
                                  <i class="material-icons material-symbols-outlined">check</i>
                                  {{ $t("content.amnclose") }}
                                </material-button>
                              </div>
                            </div>
                            <div class="row mt-3">
                              <div class="table-responsive">
                                <table class="table table-flush">
                                  <thead class="thead-light">
                                    <tr>
                                      <th class="text-center">#</th>
                                      <th class="text-center">
                                        {{ $t("content.dant") }}
                                      </th>
                                      <th class="text-center">
                                        {{ $t("content.amount") }}
                                      </th>
                                      <th class="text-center">
                                        {{ $t("content.total") }}
                                      </th>
                                      <th class="text-center">{{ $t("content.amnassetgroup") }}</th>
                                      <th class="text-center">{{ $t("content.act") }}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td class="text-sm font-weight-normal"></td>
                                      <td class="text-sm font-weight-normal">
                                        <material-input id="total" type="text" v-model="rv_detail.createDate_s"
                                          class="input-center" :disabled="true" />
                                      </td>
                                      <td class="text-sm font-weight-normal text-center">
                                        <InputNumber v-model="rv_detail.amount" autocomplete="off" fluid
                                          class="input-center" @focus="$event.target.select()" :minFractionDigits="0"
                                          :maxFractionDigits="2" :disabled="rv_detail.closed" />
                                      </td>
                                      <td class="text-sm font-weight-normal text-center">
                                        <material-input id="total" type="text" class="input-center" :disabled="true"
                                          v-model="rv_detail.remainAmount_s" />
                                      </td>
                                      <td class="text-sm font-weight-normal text-center">
                                        <select v-model="rv_detail.catUid" class="form-select"
                                          :disabled="rv_detail.closed">
                                          <option value="" disabled selected>{{ $t("content.select") }}</option>
                                          <option v-for="(index) in listallow_cat" :key="index" :data-id="index"
                                            :value="index">
                                            <span v-if="listprint.length > 0 && listallow_cat.length > 0">
                                              {{ filterCat(index) }}
                                            </span>
                                          </option>
                                        </select>
                                      </td>
                                      <td class="text-sm font-weight-normal text-center">
                                        <material-button color="info" variant="outline" class="rounded-circle"
                                          data-bs-toggle="tooltip" data-bs-placement="bottom" :title="t('buttons.addd')"
                                          :disabled="rv_detail.closed || rv_detail.amount === null || rv_detail.catUid === ''"
                                          @click="addReturnValue">
                                          <i class="material-icons material-symbols-outlined">add</i>
                                        </material-button>
                                      </td>
                                    </tr>

                                    <tr v-for="(row, index) in listrv" :key="index">
                                      <td class="text-sm font-weight-normal">
                                        {{ formatNumberString((currentPageR - 1) * perPageR + index + 1) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ format_datetime(row.createDate) }}
                                      </td>
                                      <td class="text-sm font-weight-normal text-center">
                                        {{ formatNumberDecimalString(row.amount) }}
                                      </td>
                                      <td class="text-sm font-weight-normal text-center">
                                        {{ formatNumberDecimalString(row.remainAmount) }}
                                      </td>
                                      <td class="text-sm font-weight-normal text-center"
                                        v-if="row.uid !== rve_detail.uid">
                                        <span v-if="row.catName !== null && row.catName !== ''">
                                          {{ row.catName }}
                                        </span>
                                        <span v-else>
                                          {{ row.category }}
                                        </span>
                                      </td>
                                      <td class="text-sm font-weight-normal text-center" v-else>
                                        <select v-model="rve_detail.catUid" class="form-select"
                                          :disabled="rv_detail.closed">
                                          <option value="" disabled selected>{{ $t("content.select") }}</option>
                                          <option v-for="(index) in listallow_cat" :key="index" :data-id="index"
                                            :value="index">
                                            <span v-if="listprint.length > 0 && listallow_cat.length > 0">
                                              {{ filterCat(index) }}
                                            </span>
                                          </option>
                                        </select>
                                      </td>
                                      <td v-if="row.uid === rve_detail.uid"
                                        class="text-sm font-weight-normal text-center">
                                        <material-button color="primary" variant="outline" class="rounded-circle"
                                          data-bs-toggle="tooltip" data-bs-placement="top" :title="t('buttons.save')"
                                          :disabled="rv_detail.closed || rve_detail.uid === '' || rve_detail.catUid === ''"
                                          @click="updateReturnValue">
                                          <i class="material-icons material-symbols-outlined">save</i>
                                        </material-button>
                                        <material-button color="danger" variant="outline" class="rounded-circle"
                                          data-bs-toggle="tooltip" data-bs-placement="top" :title="t('buttons.canc')"
                                          @click="cancelUpdateReturnValue">
                                          <i class="material-icons material-symbols-outlined">close</i>
                                        </material-button>
                                      </td>
                                      <td class="text-sm font-weight-normal text-center" v-else>
                                        <material-button color="info" variant="outline" class="rounded-circle"
                                          data-bs-toggle="tooltip" data-bs-placement="bottom" :title="t('buttons.edit')"
                                          :disabled="rv_detail.uid === '' || rv_detail.closed"
                                          @click="setReturnValue(row)">
                                          <i class="material-icons material-symbols-outlined">edit</i>
                                        </material-button>
                                      </td>
                                    </tr>
                                    <tr v-if="listrv.length === 0">
                                      <td colspan="10" class="text-sm font-weight-normal">
                                        <p style="text-align: center">No Record Found</p>
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td colspan="11" style="text-align: right">Total Rows : {{ totalRows_sR }}</td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                            <pre></pre>
                            <div style="display: flex; justify-content: flex-end">
                              <ul v-show="listrv.length > 0" class="pagination justify-content-end">
                                <div class="project-container">
                                  <div class="example-one">
                                    <vue-awesome-paginate v-model="currentPageR" :total-items="totalRowsR"
                                      :items-per-page="perPageR" @click="onClickHandlerR" />
                                  </div>
                                </div>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Search Customer Dialog -->
          <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeModal">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <div class="preview-table">
                    <section class="panel">
                      <table class="table table-striped table-responsive">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>{{ $t("content.cnameth") }}</th>
                            <th>{{ $t("content.cnameen") }}</th>
                            <th>{{ $t("content.docno") }}</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="row-search">
                            <td></td>
                            <td>
                              <material-input v-model="nameThC" type="text" :label="t('content.cnameth')" />
                            </td>
                            <td>
                              <material-input v-model="nameEnC" type="text" :label="t('content.cnameen')" />
                            </td>
                            <td>
                              <material-input v-model="docNumberC" type="text" :label="t('content.docno')" />
                            </td>
                            <td>
                              <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                                data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch"
                                :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                                @click="loadCustomerAfListApi">
                                <i class="material-icons material-symbols-outlined">search</i>
                              </material-button>
                            </td>
                          </tr>
                          <tr v-for="(row, index) in customerlist" :key="index" @click="selectCus(row)">
                            <td>{{ formatNumberString((currentPageC - 1) * perPageC + index + 1) }}</td>
                            <td>{{ row.nameTh }}</td>
                            <td>{{ row.nameEn }}</td>
                            <td colspan="2">{{ row.docNumber }}</td>
                          </tr>
                          <tr v-if="customerlist.length === 0">
                            <td colspan="5" class="text-sm font-weight-normal">
                              <p style="text-align: center">No Record Found</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                  </div>
                </div>

                <div class="modal-footer">
                  <pre></pre>
                  <div style="display: flex; justify-content: flex-end">
                    <ul v-show="customerlist.length > 0" class="pagination justify-content-end">
                      <div class="project-container">
                        <div class="example-one">
                          <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                            :items-per-page="perPageC" @click="onClickHandlerC" />
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Add New List Dialog -->
          <div id="newUnitOverHistoryManageModal" class="modal fade" tabindex="-1"
            aria-labelledby="newUnitOverHistoryManageModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{{ $t("content.amnunitovermng") }}</h4>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <div class="row">
                    <div class="col-lg-4">
                      <label class="form-label ms-0 mb-0 me-3">{{
                        $t("content.ticketno")
                      }}</label>
                      <material-input id="ticketno" v-model="coll_detail.refno" type="text" :disabled="true" />
                    </div>
                    <div class="col-lg-4">
                      <label class="form-label ms-0 mb-0 me-3">{{
                        $t("content.stockno")
                      }}</label>
                      <material-input id="stockno" v-model="coll_detail.stockno" type="text" :disabled="true" />
                    </div>
                    <div class="col-lg-4">
                      <label class="form-label ms-0 mb-0 me-3">{{
                        $t("content.lotno")
                      }}</label>
                      <material-input id="lotno" v-model="coll_detail.lotno" type="text" :disabled="true" />
                    </div>
                    <hr class="split-sect" />
                  </div>

                  <fieldset>
                    <div class="row">
                      <div class="table-responsive">
                        <table class="table table-flush">
                          <thead class="thead-light">
                            <tr>
                              <th>#</th>
                              <th class="text-center">{{ $t("content.item") }}</th>
                              <th class="text-center">
                                {{ $t("content.amnanalysval") }}
                              </th>
                              <th class="text-center">{{ $t("content.approxprice") }}</th>
                              <th class="text-center">{{ $t("content.note") }}</th>
                              <th class="text-center">{{ $t("content.amnunpack") }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, index) in coll_detail.collaterals" :key="index">
                              <td class="text-sm font-weight-normal text-center">
                                {{ formatNumberString(index + 1) }}
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                {{ row.detail }}
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                <material-input type="text" class="input-center" v-model="row.pawnValue_s" disabled />
                              </td>
                              <td class="text-sm font-weight-normal">
                                <InputNumber v-model="row.estimatePrice" autocomplete="off" fluid class="input-center"
                                  @focus="$event.target.select()" :minFractionDigits="0" :maxFractionDigits="2"
                                  @update:modelValue="calEstimate"
                                  :disabled="filterCat(coll_detail.catUid) === 'ทอง' || lotStatus === 'COMPLETE' || estEStatus" />
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                <material-input v-model="row.remark" type="text" class="input-center"
                                  :disabled="lotStatus === 'COMPLETE' || estEStatus" />
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                <material-checkbox v-model="row.separate" :checked="row.separate"
                                  :disabled="lotStatus === 'COMPLETE' || estEStatus" />
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr v-for="(i, ov2) in 1" :key="ov2">
                              <td class="text-sm font-weight-bold"></td>
                              <td class="text-sm font-weight-bold text-center">
                                <h6>
                                  <b>{{ $t("content.amnpriceall") }}</b>
                                </h6>
                              </td>
                              <td class="text-sm font-weight-bold text-center">
                                <material-input type="text" class="input-center" disabled />
                              </td>
                              <td class="text-sm font-weight-bold text-center">
                                <material-input type="text" class="input-center" disabled />
                              </td>
                              <td class="text-sm font-weight-bold text-center">
                                <material-input type="text" class="input-center" disabled />
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr v-for="(i, ov3) in 1" :key="ov3">
                              <td class="text-sm font-weight-bold"></td>
                              <td class="text-sm font-weight-bold text-center">
                                <h6>
                                  <b>{{ $t("content.amngrandtotal") }}</b>
                                </h6>
                              </td>
                              <td class="text-sm font-weight-bold text-center">
                                <h6>
                                  <b> {{ formatNumberDecimalString(pawn_tt) }}</b>
                                </h6>
                              </td>
                              <td class="text-sm font-weight-bold text-center">
                                <h6>
                                  <b>{{ formatNumberDecimalString(esti_tt) }}</b>
                                </h6>
                              </td>
                              <td class="text-sm font-weight-bold text-center"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div class="modal-footer justify-content-between">
                  <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                    {{ cancel }}
                  </button>
                  <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                    :disabled="esti_tt === null || Number(esti_tt) < 0 || lotStatus === 'COMPLETE' || estEStatus 
                    || coll_detail.collaterals.filter(item => item.estimatePrice === null || item.estimatePrice === '' ).length > 0" @click="updateCollateral">
                    {{ save }}
                  </button>
                </div>
              </div>
            </div>
          </div>


          <!-- Detail Modal -->
          <TicketDetailModal 
          v-if="workcaseDetail !== null"
          :workcaseDetail="workcaseDetail"
          :images="images"
          :listinfo="listinfo"
          :paymentE="paymentE"
          :paymentL="payment_l"
          :promotionDetail="promotionDetail"
          :depRef="dep_ref"
          :tkStatus="tk_status"
          :intCal="int_cal"
          :intPeriod="int_period"
          :transactionLabel="checkTransaction(workcaseDetail.transactionType)"
          :history="'no'" 
          v-model:fcusdt="fcusdt" 
          :afChangename=af_changename
          :bfChangename=bf_changename
          :transDatePrv=transdate_prv
          @copy="copyBtn"
          @openHistory="NewTab"/>
          


          <!-- Estimate Gold Dialog -->
          <div id="estimateGoldManageModal" class="modal fade" tabindex="-1"
            aria-labelledby="estimateGoldManageModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{{ $t("content.amnunitovermng") }} ({{ $t("content.amngold") }})</h4>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <fieldset>
                    <div class="row">
                      <div class="table-responsive">
                        <table class="table table-flush">
                          <thead class="thead-light">
                            <tr>
                              <th class="text-center">{{ $t("content.lotno") }}</th>
                              <th class="text-center">{{ $t("content.approxprice") }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(i, ov3) in 1" :key="ov3">
                              <td class="text-sm font-weight-bold text-center">
                                <material-input id="lotno" v-model="est_detail.lotno" type="text" :disabled="true"
                                  class="input-center" />
                              </td>
                              <td class="text-sm font-weight-bold text-center">
                                <InputNumber v-model="est_detail.estimatePrice" autocomplete="off" fluid
                                  class="input-center" @focus="$event.target.select()" :minFractionDigits="0"
                                  :maxFractionDigits="2" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div class="modal-footer justify-content-between">
                  <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                    {{ cancel }}
                  </button>
                  <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                    :disabled="est_detail.estimatePrice === null || est_detail.estimatePrice === '' || Number(est_detail.estimatePrice) < 0"
                    @click="checkEstGoldProcess">
                    {{ save }}
                  </button>
                </div>
              </div>
            </div>
          </div>


        <!-- Gallery Modal -->
        <div id="galleryModal" class="modal fade" tabindex="-1" aria-labelledby="galleryModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style="max-width: 520px">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.detail") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <div id="lookupImages2" class="carousel slide" data-bs-touch="false" data-bs-interval="false">
                  <div class="carousel-indicators">
                    <div class="carousel-indicators" id="demo2">
                    </div>
                  </div>
                  <div class="carousel-inner">
                    <ul className="list-unstyled">
                      <li v-for="(item, index) in images.length" :key="index">
                        <span v-if="index === 0">
                          <div class="carousel-item active">
                            <vue-image-zoomer :regular="images[index].src" img-class="img-fluid" class="d-block w-100"
                              :zoom-amount="3" :click-zoom="true" close-pos="top-right" message-pos="top" />
                          </div>
                        </span>
                        <span v-else>
                          <div class="carousel-item">
                            <vue-image-zoomer :regular="images[index].src" img-class="img-fluid" class="d-block w-100"
                              :zoom-amount="3" :click-zoom="true" close-pos="top-right" message-pos="top" />
                          </div>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <button class="carousel-control-prev" type="button" data-bs-target="#lookupImages2"
                    data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button class="carousel-control-next" type="button" data-bs-target="#lookupImages2"
                    data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import MultiSelect from 'primevue/multiselect';
import InputNumber from 'primevue/inputnumber';
import ProgressSpinner from 'primevue/progressspinner';
import { reactive, computed, ref, inject, onMounted, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialMultiSelect from "@/components/MaterialMultiSelect.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ExampleFive from "@/examples/ExampleOne";
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import TicketDetailModal from '@/components/TicketDetailModal.vue';

import moment from 'moment'
import noImg from "@/assets/img/noimg.png"
import axios from "axios";
import * as st from "@/config/setting.js";

import { useLotStore } from '@/stores/lot'
import { useCashAccountStore } from '@/stores/cashaccount'
import { useCustomerStore } from '@/stores/customer'
import { useBreakingStore } from '@/stores/breaking'
import { useCategoryStore } from '@/stores/category'
import { useShopCatOrderStore } from '@/stores/shopcatorder'
import { useInterestStore } from '@/stores/interest'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useWorkCaseStore } from '@/stores/workcase'
import { useRecodeStore } from '@/stores/record'
import { useShopStore } from '@/stores/shop'
import { useEstGoldStore } from '@/stores/estgold'
import { useDepositStore } from '@/stores/deposit'
import { useDocumentStore } from '@/stores/document'


const storelo = useLotStore()
const storeca = useCashAccountStore()
const storecus = useCustomerStore()
const storebk = useBreakingStore()
const storec = useCategoryStore()
const storeco = useShopCatOrderStore()
const storei = useInterestStore()
const storewc = useWorkCaseStore()
const storepm = usePaymentGroupStore()
const storerc = useRecodeStore()
const storesh = useShopStore()
const storeest = useEstGoldStore()
const storedepo = useDepositStore()
const storedoc = useDocumentStore()



const { t } = useI18n();
const swal = inject("$swal");

///// computed
const cancel = computed(() => t("buttons.canc"));
const save = computed(() => t("buttons.save"));
const btnSearch = computed(() => t("buttons.sear"));

const listhis = ref([]);
const start_hdate = ref(new Date(new Date().setHours(0, 0, 0, 0)));
const end_hdate = ref(new Date());
const cat_hsearch = ref('');
const cusUid_search = ref('');
const cusName_search = ref('');
const tk_hsearch = ref('');
const stock_hsearch = ref('');
const lot_hsearch = ref('');
const status_hsearch = ref('');

const customerlist = ref([])
const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();

const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')

const currentPageH = ref(1);
const totalRowsH = ref(1);
const perPageH = ref(30);
const totalRows_sH = ref();

const currentPageB = ref(1);
const totalRowsB = ref(1);
const perPageB = ref(30);
const totalRows_sB = ref();

const loading = ref(false);
const shop_detail = ref(null)
const shop_info = ref(null)
const listcat_order = ref([]);
const listprint = ref([]);
const listcat_name = ref([]);
const listallow_cat = ref([]);


const listbk = ref([]);
const status_search = ref('');
const lot_search = ref('');

const listlot = ref([]);
const currentPageR = ref(1);
const totalRowsR = ref(1);
const perPageR = ref(30);
const totalRows_sR = ref();

const listrvl = ref([]);
const lrvl_search = ref('');


const currentPageLR = ref(1);
const totalRowsLR = ref(1);
const perPageLR = ref(30);
const totalRows_sLR = ref();

const listrv = ref([]);

const currentPageRC = ref(1);
const totalRowsRC = ref(1);
const perPageRC = ref(30);
const totalRows_sRC = ref();

const listrc = ref([]);
const lrc_search = ref('');
const lurc_search = ref('');
const catrc_search = ref('');
const stockrc_search = ref('');
const pawn_tt = ref(0);
const esti_tt = ref(0);
const lotStatus = ref('');
const estEStatus = ref(false);

const listcoll = ref([]);
const promotionDetail = ref(null);
const fcusdt = ref(false)
const bf_changename = ref('');
const af_changename = ref('');
const transdate_prv = ref(null);

const rv_detail = ref({
  uid: '',
  lotUid: '',
  amount: 0,
  category: [],
  version: '',
  lotNo: '',
  numOfTicket: '',
  quantity: 0,
  pawnValue: 0,
  closed: false,
  remainAmount: 0,
  createDate: new Date(),
  remainAmount_s: '',
  createDate_s: '',
  numOfTicket_s: '',
  quantity_s: '',
  pawnValue_s: '',
  catUid: '',
  catName: '',
})

const coll_detail = ref({
  recordUid: '',
  version: '',
  collaterals: [],
  refno: '',
  stockno: '',
  lotno: '',
  catUid: ''
})


const info_cat = ref('');
const workcaseDetail = ref(null);
const tk_status = ref('');
const int_cal = ref(0);
const paymentE = ref('');
const listinfo = ref([]);
const payment_l = ref([])
const int_period = ref('');
const images = ref([])
const images_l = ref([])
const dep_ref = ref('');
const time = ref(true);

const start_month = ref({
    month: new Date().getMonth(),
    year: new Date().getFullYear()
});

const end_month = ref({
    month: new Date().getMonth(),
    year: new Date().getFullYear()
});

const max_month = ref({
    month: new Date().getMonth(),
    year: new Date().getFullYear()
});


const list_odstatus = ref([
  { items: computed(() => t("content.optall")), value: '' },
  { items: computed(() => t("content.amnunitover")), value: 'BREAKING' },
  { items: computed(() => t("content.amnstateacting")), value: 'ACTIVE' },
  { items: computed(() => t("content.scanin")), value: 'SCAN_IN' },
  { items: computed(() => t("content.scanout")), value: 'SCAN_OUT' },
  { items: computed(() => t("content.evalcom")), value: 'ESTIMATION_COMPLETE' },
  { items: computed(() => t("content.status_finish")), value: 'COMPLETE' },
])


const est_detail = ref({
  uid: '',
  estimatePrice: 0,
  remark: '',
  version: '',
  lotno: '',
})

const rve_detail = ref({
  uid: '',
  category: [],
  version: '',
  pawnValue: 0,
  remainAmount: 0,
  createDate: new Date(),
  catUid: '',
  catName: '',
})

const textInputOptions = {
  format: 'dd/MM/yyyy'
};

const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY');
}

function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
  }
}

function format_date(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY')
  }
}

function copyBtn() {
  navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}


const NewTab = async () => {
  sessionStorage.removeItem('deferWorkcaseUid');
  sessionStorage.setItem("deferWorkcaseUid", workcaseDetail.value.uid);
  if (sessionStorage.getItem('deferWorkcaseUid') !== null) {
    const win = window.open("#/generals/defer_items", "_blank");
    win.focus();
    sessionStorage.removeItem('deferWorkcaseUid');
  }
}


// const format = (date) => {
//   return moment(String(date)).local().format('DD/MM/YYYY HH:mm');
// }

const textInputOptions_month = {
  format: 'MM/yyyy'
};


const format_month = (date) => {
  return moment(String(date)).local().format('MM/YYYY');
}

const onserachDate = () => {
  start_month.value = ({
    month: new Date().getMonth(),
    year: new Date().getFullYear()
  });
  end_month.value = ({
    month: new Date().getMonth(),
    year: new Date().getFullYear()
  });
}




function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

const onClickHandlerH = () => {
  updatePaginationHistory()
};

const onClickHandlerC = () => {
  updatePaginationC()
};

const onClickHandlerBk = () => {
  updatePaginationBk()
};

const onClickHandlerRC = () => {
  updatePaginationRC()
};

const onClickHandlerR = () => {
  updatePaginationRv()
};

const onClickHandlerLR = () => {
  updatePaginationLRv()
};


const InfoFromSession = async (val) => {
  shop_detail.value = null
  const response = await storeca.cashaccountInfoFromSessionFetch();
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_detail.value = response.data.data
        await loadDataPrintApi()
        await loadBreakingListApi()
      }
    }
  }
}

InfoFromSession()

const loadDataPrintApi = async () => {
  let data = "";
  data = {
    uid: "",
  };
  const payload = data;
  const response = await storec.categorylistPrintFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listprint.value = response.data.data;
        if (listcat_order.value.length === 0) {
          await loadDataOrderCatApi()
        }
      }
    }
  }
}

async function loadDataOrderCatApi() {
  listcat_order.value = []
  listcat_name.value = []
  let data = "";
  let list = []
  data = {
    index: 0,
    size: '100',
    shopUid: shop_detail.value.uid
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storeco.shopCatOrderListFetch(payload);
  // console.log("cat_order : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        list = response.data.data.list;
        if (list.length !== 0) {
          listcat_order.value = list[0].catOrders
          listcat_order.value = Object.values(listcat_order.value)
          for (let i = 0; i < listcat_order.value.length; i++) {
            listcat_name.value.push({ name: filterCat(listcat_order.value[i]) })
          }
          // console.log("listcat_order : " + JSON.stringify(listcat_order.value));
        }
      }
    }
  }
}

function cancelHistoryBtn() {
  start_hdate.value = new Date();
  end_hdate.value = new Date();
  cat_hsearch.value = ''
  cusUid_search.value = ''
  cusName_search.value = ''
  tk_hsearch.value = ''
  stock_hsearch.value = ''
  lot_hsearch.value = ''
  status_hsearch.value = ''
  currentPageH.value = 1
  listhis.value = []
  totalRowsH.value = 0
  totalRows_sH.value = ''
}


async function loadHistoryListApi() {

  if (cat_hsearch.value !== '' || cusUid_search.value !== '' || tk_hsearch.value !== '' || stock_hsearch.value !== '' || lot_hsearch.value !== '' || status_hsearch.value !== '') {
    currentPageH.value = 1
  }
  let data = "";
  data = {
    index: currentPageH.value - 1,
    size: perPageH.value,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    fromDate: moment(new Date(start_hdate.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_hdate.value)).format('YYYY-MM-DDT23:59:59'),
    catUid: cat_hsearch.value,
    cusUid: cusUid_search.value,
    tkRefNumber: tk_hsearch.value,
    stockNo: stock_hsearch.value,
    lotNumber: lot_hsearch.value,
    action: status_hsearch.value,
  };
  const payload = data;
  // console.log("lh p : " + JSON.stringify(payload));
  const response = await storebk.historyListFetch(payload);
  // console.log("lh r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listhis.value = response.data.data.list
        totalRowsH.value = response.data.data.ext.total
        totalRows_sH.value = formatNumberString(totalRowsH.value)
      }
    }
  }
};


async function updatePaginationHistory() {
  listhis.value = []
  let data = "";
  data = {
    index: currentPageH.value - 1,
    size: perPageH.value,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    fromDate: moment(new Date(start_hdate.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_hdate.value)).format('YYYY-MM-DDT23:59:59'),
    catUid: cat_hsearch.value,
    cusUid: cusUid_search.value,
    tkRefNumber: tk_hsearch.value,
    stockNo: stock_hsearch.value,
    lotNumber: lot_hsearch.value,
    action: status_hsearch.value,
  };
  const payload = data;
  const response = await storebk.historyListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listhis.value = response.data.data.list
        totalRowsH.value = response.data.data.ext.total
        totalRows_sH.value = formatNumberString(totalRowsH.value)
      }
    }
  }
}


async function loadBreakingListApi() {
  currentPageB.value = 1

  let start = ""
  let end = ""
  
  if (time.value === true) { 
    // 1. แปลงเป็น Date Object (วันแรกของเดือน)
    const firstDay = new Date(start_month.value.year, start_month.value.month, 1);
    // 2. หาค่าวันสุดท้ายของเดือน
    // เคล็ดลับ: ใช้ month + 1 และวันที่เป็น 0
    const lastDay = new Date(end_month.value.year, end_month.value.month + 1, 0);

    start = moment(new Date(firstDay)).format('YYYY-MM-DDT00:00:00')
    end = moment(new Date(lastDay)).format('YYYY-MM-DDT23:59:59')
  }

  let data = "";
  data = {
    index: currentPageB.value - 1,
    size: perPageB.value,
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    status: status_search.value,
    lotNumber: lot_search.value,
    fromDate: start,
    toDate: end,
  };
  const payload = data;
  const response = await storelo.lotListFetch(payload);
  // console.log("bl : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listbk.value = response.data.data.list
        totalRowsB.value = response.data.data.ext.total
        totalRows_sB.value = formatNumberString(totalRowsB.value)
      }
    }
  }
};


async function updatePaginationBk() {
  listbk.value = []
  let start = ""
  let end = ""
  
  if (time.value === true) { 
    // 1. แปลงเป็น Date Object (วันแรกของเดือน)
    const firstDay = new Date(start_month.value.year, start_month.value.month, 1);
    // 2. หาค่าวันสุดท้ายของเดือน
    // เคล็ดลับ: ใช้ month + 1 และวันที่เป็น 0
    const lastDay = new Date(end_month.value.year, end_month.value.month + 1, 0);

    start = moment(new Date(firstDay)).format('YYYY-MM-DDT00:00:00')
    end = moment(new Date(lastDay)).format('YYYY-MM-DDT23:59:59')
  }
  let data = "";
  data = {
    index: currentPageB.value - 1,
    size: perPageB.value,
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    status: status_search.value,
    lotNumber: lot_search.value,
    fromDate: start,
    toDate: end,
  };
  const payload = data;
  const response = await storelo.lotListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listbk.value = response.data.data.list
        totalRowsB.value = response.data.data.ext.total
        totalRows_sB.value = formatNumberString(totalRowsB.value)
      }
    }
  }
}

function clearItemRv() {
  rv_detail.value = {
    uid: '',
    lotUid: '',
    amount: 0,
    category: [],
    version: '',
    lotNo: '',
    numOfTicket: '',
    quantity: 0,
    pawnValue: 0,
    closed: false,
    remainAmount: 0,
    createDate: new Date(),
    remainAmount_s: '',
    createDate_s: '',
    numOfTicket_s: '',
    quantity_s: '',
    pawnValue_s: '',
    catUid: '',
    catName: '',
  }
}

function clearItemRecord() {
  coll_detail.value = {
    recordUid: '',
    version: '',
    collaterals: [],
    refno: '',
    stockno: '',
    lotno: '',
    catUid: ''
  }
  pawn_tt.value = 0
  esti_tt.value = 0
}

async function setColl(item) {
  listcoll.value = []
  estEStatus.value = false
  clearItemRecord()
  coll_detail.value = {
    recordUid: item.uid,
    version: item.version,
    collaterals: [],
    refno: item.tkRefNumber,
    stockno: item.stockNumber,
    lotno: item.lotNumber,
    catUid: item.catUid
  }
  if (item.estCompleteDate !== null) {
    var startDate = new Date(item.estCompleteDate);
    var endDate = new Date();
    var Difference_In_Time = Math.abs(endDate - startDate);
    var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 60 * 60 * 24));
    if (Difference_In_Days > 2) {
      estEStatus.value = true
    }
  }
  // console.log("setColl : " + JSON.stringify(item));
  await loadcollateralList()
  if (listcoll.value.length > 0) {
    // console.log("listcoll : " + JSON.stringify(listcoll.value));
    for (let i = 0; i < listcoll.value.length; i++) {
      pawn_tt.value = pawn_tt.value + listcoll.value[i].pawnValue
      esti_tt.value = esti_tt.value + listcoll.value[i].estimatePrice
    }
    coll_detail.value.collaterals = listcoll.value
    document.getElementById("collateralModal").click();
  }


}

async function calEstimate() {
  esti_tt.value = 0
  for (let i = 0; i < coll_detail.value.collaterals.length; i++) {
    if (coll_detail.value.collaterals[i].estimatePrice !== null && coll_detail.value.collaterals[i].estimatePrice !== '') {
      esti_tt.value = esti_tt.value + coll_detail.value.collaterals[i].estimatePrice
    }
  }
}


async function setRecode(item) {
  clearItemRecord()
  lurc_search.value = item.uid
  lrc_search.value = item.lotNumber
  catrc_search.value = ''
  stockrc_search.value = ''
  listrc.value = []
  currentPageRC.value = 1
  totalRowsRC.value = 0
  totalRows_sRC.value = ''
  lotStatus.value = item.status
  await loadRecodeListApi()
  await setthirdTab()
}

async function loadRecodeListApi() {
  let data = "";
  data = {
    index: currentPageRC.value - 1,
    size: perPageRC.value,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    lotUid: lurc_search.value,
    catUid: catrc_search.value,
    stockNumber: "",
    status: '',
  };
  const payload = data;
  // console.log("rcl p : " + JSON.stringify(payload));
  const response = await storerc.recordListFetch(payload);
  // console.log("RecodeList r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listrc.value = response.data.data.list
        totalRowsRC.value = response.data.data.ext.total
        totalRows_sRC.value = formatNumberString(totalRowsRC.value)
      }
    }
  }
};


async function updatePaginationRC() {
  listlot.value = []
  let data = "";
  data = {
    index: currentPageRC.value - 1,
    size: perPageRC.value,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    lotUid: lurc_search.value,
    catUid: catrc_search.value,
    stockNumber: "",
    status: '',
  };
  const payload = data;
  const response = await storerc.recordListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listrc.value = response.data.data.list
        totalRowsRC.value = response.data.data.ext.total
        totalRows_sRC.value = formatNumberString(totalRowsRC.value)
      }
    }
  }
}

async function loadcollateralList() {
  let list = []
  let data = "";
  data = {
    index: 0,
    size: 100,
    recordUid: coll_detail.value.recordUid
  };
  const payload = data;
  // console.log("loadcoll p : " + JSON.stringify(payload));
  const response = await storerc.collateralListFetch(payload);
  // console.log("loadcoll r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        list = response.data.data.list
        list.map(function (x) {
          x.pawnValue_s = formatNumberDecimalString(x.pawnValue);
          return x
        });
        listcoll.value = list
      } else {
        swal(response.data.rtnDesc, "", "error");
      }
    }
  }
}


async function updateCollateral() {
  const payload = coll_detail.value;
  // console.log("ucoll p : " + JSON.stringify(payload));
  const response = await storerc.updateCollateralFetch(payload);
  // console.log("ucoll p : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        await loadRecodeListApi()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}


async function setRv(item) {
  clearItemRv()
  rv_detail.value = {
    uid: item.uid,
    lotUid: item.uid,
    amount: 0,
    category: [],
    version: item.version,
    lotNo: item.lotNumber,
    numOfTicket: item.numOfTicket,
    quantity: item.quantity,
    pawnValue: item.pawnValue,
    closed: false,
    remainAmount: item.remainAmount,
    createDate: new Date(),
    remainAmount_s: formatNumberDecimalString(item.remainAmount),
    createDate_s: format_datetime(new Date()),
    numOfTicket_s: formatNumberString(item.numOfTicket),
    quantity_s: formatNumberString(item.quantity),
    pawnValue_s: formatNumberDecimalString(item.pawnValue),
    catUid: '',
    catName: '',
  }
  await listAllowCat()
  if (item.status === 'COMPLETE') {
    rv_detail.value.closed = true
  }

  await returnValueList()
  await setsubSecondTab()
}


async function lotReturnList(val) {
  listrvl.value = []
  currentPageLR.value = 1
  totalRows_sLR.value = ''
  totalRowsLR.value = 0
  let data = "";
  data = {
    index: currentPageLR.value - 1,
    size: perPageLR.value,
    lotNumber: lrvl_search.value,
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    fromDate: "",
    toDate: "",
  };
  const payload = data;
  // console.log("lrv p : " + JSON.stringify(payload));
  const response = await storelo.lotListFetch(payload);
  // console.log("lrv r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listrvl.value = response.data.data.list
        totalRowsLR.value = response.data.data.ext.total
        totalRows_sLR.value = formatNumberString(totalRowsLR.value)
      }
    }
  }
  if (val === 'search') {
    clearItemRv()
    listrv.value = []
    currentPageR.value = 1
    totalRowsR.value = 0
    totalRows_sR.value = ''
  }
}

async function updatePaginationLRv() {
  let data = "";
  data = {
    index: currentPageLR.value - 1,
    size: perPageLR.value,
    lotNumber: lrvl_search.value,
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    fromDate: "",
    toDate: "",
  };
  const payload = data;
  // console.log("lrv p : " + JSON.stringify(payload));
  const response = await storelo.lotListFetch(payload);
  // console.log("lrv r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listrvl.value = response.data.data.list
        totalRowsLR.value = response.data.data.ext.total
        totalRows_sLR.value = formatNumberString(totalRowsLR.value)
      }
    }
  }
}



async function returnValueList() {
  let data = "";
  data = {
    index: currentPageR.value - 1,
    size: perPageR.value,
    lotUid: rv_detail.value.lotUid
  };
  const payload = data;
  const response = await storelo.returnValueListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listrv.value = response.data.data.list
        totalRowsR.value = response.data.data.ext.total
        totalRows_sR.value = formatNumberString(totalRowsR.value)
        if (listrv.value.length > 0) {
          rv_detail.value.remainAmount_s = listrv.value[listrv.value.length - 1].remainAmount
          rv_detail.value.remainAmount_s = formatNumberDecimalString(listrv.value[listrv.value.length - 1].remainAmount)
        }
        rv_detail.value.createDate_s = format_datetime(new Date())
      }
    }
  }
}

async function updatePaginationRv() {
  let data = "";
  data = {
    index: currentPageR.value - 1,
    size: perPageR.value,
    lotUid: rv_detail.value.lotUid
  };
  const payload = data;
  const response = await storelo.returnValueListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listrv.value = response.data.data.list
        totalRowsR.value = response.data.data.ext.total
        totalRows_sR.value = formatNumberString(totalRowsR.value)
      }
    }
  }
}

async function addReturnValue() {
  let catuid = ''
  let catname = ''
  if (rv_detail.value.catUid === '') {
    catuid = 0
  } else {
    catuid = rv_detail.value.catUid
    catname = filterCat(rv_detail.value.catUid)
  }

  const payload = {
    lotUid: rv_detail.value.lotUid,
    amount: rv_detail.value.amount,
    catUid: catuid,
    catName: catname
  }

  // console.log("addrv p : " + JSON.stringify(payload));
  const response = await storelo.addReturnValueFetch(payload);
  // console.log("addrv r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        rv_detail.value.amount = 0
        rv_detail.value.category = ''
        rv_detail.value.catUid = ''
        rv_detail.value.catName = ''
        await lotReturnInfo()
        await returnValueList()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function completeLot() {
  const payload = {
    uid: rv_detail.value.uid, // lot uid
    version: rv_detail.value.version,
  };
  // console.log("comrv p : " + JSON.stringify(payload));
  const response = await storelo.completeLotFetch(payload);
  // console.log("comrv r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        await lotReturnList('search')
        await setsubFirstTab()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}


async function lotReturnInfo() {
  let rvlinfo = []
  let data = "";
  data = {
    index: 0,
    size: 100,
    lotNumber: lrvl_search.value,
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    fromDate: "",
    toDate: "",
  };
  const payload = data;
  // console.log("lrv p : " + JSON.stringify(payload));
  const response = await storelo.lotListFetch(payload);
  // console.log("rvlinfo r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        rvlinfo = response.data.data.list
        rv_detail.value.version = rvlinfo[0].version
      }
    }
  }
}



async function openDialogCus() {
  nameThC.value = ''
  nameEnC.value = ''
  docNumberC.value = ''
  cusUid_search.value = ''
  cusName_search.value = ''
  customerlist.value = []
  document.getElementById("searchNameCus").click();
}

async function selectCus(item) {
  cusUid_search.value = item.uid
  cusName_search.value = item.nameTh
  document.getElementById("closeModal").click();
}

async function loadCustomerAfListApi() {
  currentPageC.value = 1
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value,    
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid

  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCustomerListApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        customerlist.value = listd;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}


async function updatePaginationC() {
  customerlist.value = []
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value,    
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid

  };
  const payload = data;
  const response = await storecus.searchCustomerFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        customerlist.value = response.data.data.list;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}

async function onClickTab(val) {
  if (val === '1') {
    if (new Date(start_hdate.value) <= new Date(end_hdate.value)) {
      currentPageH.value = 1
      totalRowsH.value = 0
      totalRows_sH.value = ''
      await loadHistoryListApi()
    }
    await setfirstTab()
  } else if (val === '2') {
    if ((time.value === true && new Date(start_month.value.year, start_month.value.month) <= new Date(end_month.value.year, end_month.value.month))) {
      await loadBreakingListApi()
    }
    await setsecondTab()
  } else if (val === '3') {
    if (lurc_search.value !== '') {
      await loadRecodeListApi()
    }
    await setthirdTab()
  } else if (val === '4') {
    if (lrvl_search.value !== '') {
      await lotReturnList()
    }
    await setfourthTab()
  }
}


async function setfirstTab() {
  if (document.getElementById("second-unitoverhis")) {
    document.getElementById("second-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("secondUnitoverHis")) {
    document.getElementById("secondUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("third-unitoverhis")) {
    document.getElementById("third-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("thirdUnitoverHis")) {
    document.getElementById("thirdUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("fourth-unitoverhis")) {
    document.getElementById("fourth-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("fourthUnitoverHis")) {
    document.getElementById("fourthUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("first-unitoverhis")) {
    document.getElementById("first-unitoverhis").classList.add('show', 'active')
  }

  if (document.getElementById("firstUnitoverHis")) {
    document.getElementById("firstUnitoverHis").classList.add('show', 'active')
  }
}

async function setsecondTab() {

  if (document.getElementById("first-unitoverhis")) {
    document.getElementById("first-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("firstUnitoverHis")) {
    document.getElementById("firstUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("third-unitoverhis")) {
    document.getElementById("third-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("thirdUnitoverHis")) {
    document.getElementById("thirdUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("fourth-unitoverhis")) {
    document.getElementById("fourth-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("fourthUnitoverHis")) {
    document.getElementById("fourthUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("second-unitoverhis")) {
    document.getElementById("second-unitoverhis").classList.add('show', 'active')
  }

  if (document.getElementById("secondUnitoverHis")) {
    document.getElementById("secondUnitoverHis").classList.add('show', 'active')
  }
}


async function setthirdTab() {

  if (document.getElementById("first-unitoverhis")) {
    document.getElementById("first-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("firstUnitoverHis")) {
    document.getElementById("firstUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("second-unitoverhis")) {
    document.getElementById("second-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("secondUnitoverHis")) {
    document.getElementById("secondUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("fourth-unitoverhis")) {
    document.getElementById("fourth-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("fourthUnitoverHis")) {
    document.getElementById("fourthUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("third-unitoverhis")) {
    document.getElementById("third-unitoverhis").classList.add('show', 'active')
  }

  if (document.getElementById("thirdUnitoverHis")) {
    document.getElementById("thirdUnitoverHis").classList.add('show', 'active')
  }

}

async function setfourthTab() {

  if (document.getElementById("first-unitoverhis")) {
    document.getElementById("first-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("firstUnitoverHis")) {
    document.getElementById("firstUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("second-unitoverhis")) {
    document.getElementById("second-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("secondUnitoverHis")) {
    document.getElementById("secondUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("third-unitoverhis")) {
    document.getElementById("third-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("thirdUnitoverHis")) {
    document.getElementById("thirdUnitoverHis").classList.remove('show', 'active')
  }


  if (document.getElementById("fourth-unitoverhis")) {
    document.getElementById("fourth-unitoverhis").classList.add('show', 'active')
  }

  if (document.getElementById("fourthUnitoverHis")) {
    document.getElementById("fourthUnitoverHis").classList.add('show', 'active')
  }
}


async function onClickSubTab(val) {
  if (val === '1') {
    await setsubFirstTab()
  } else if (val === '2') {
    await setsubSecondTab()
  }
}

async function setsubFirstTab() {
  if (document.getElementById("third-saveunitoverhis")) {
    document.getElementById("third-saveunitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("thirdSaveUnitoverHis")) {
    document.getElementById("thirdSaveUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("second-saveunitoverhis")) {
    document.getElementById("second-saveunitoverhis").classList.add('show', 'active')
  }

  if (document.getElementById("secondSaveUnitoverHis")) {
    document.getElementById("secondSaveUnitoverHis").classList.add('show', 'active')
  }

}


async function setsubSecondTab() {
  if (document.getElementById("second-saveunitoverhis")) {
    document.getElementById("second-saveunitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("secondSaveUnitoverHis")) {
    document.getElementById("secondSaveUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("third-saveunitoverhis")) {
    document.getElementById("third-saveunitoverhis").classList.add('show', 'active')
  }

  if (document.getElementById("thirdSaveUnitoverHis")) {
    document.getElementById("thirdSaveUnitoverHis").classList.add('show', 'active')
  }
}

function filterCat(str) {
  let side = ''
  let name = listprint.value.filter((c) => c.uid === str);
  if (name.length > 0) {
    side = name[0].name
  }
  return side
}




function filterODStatus(str) {
  let side = ''
  let name = list_odstatus.value.filter((c) => c.value === str);
  if (name.length > 0) {
    side = name[0].items
  }
  return side
}

async function openDetail(item) {
  workcaseDetail.value = null
  images.value = []
  images_l.value = []
  listinfo.value = []
  tk_status.value = ''
  int_cal.value = 0
  paymentE.value = ''
  int_period.value = ''
  fcusdt.value = false
  dep_ref.value = ''
  bf_changename.value = ''
  af_changename.value = ''
  transdate_prv.value = null
  promotionDetail.value = null

  await getworkCaseInfo(item.workCaseUid)
  if (workcaseDetail.value != null) {

    if (workcaseDetail.value.changeName ) {
      af_changename.value = item.cusName
      getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
    }else { 
      if (workcaseDetail.value.transactionType !== 'PAWN') { 
          getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
      }
    }

    if (workcaseDetail.value.deposit) {
      getDepositInfo(workcaseDetail.value.tkRefNumber)
    }
    detailPayment(workcaseDetail.value.paymentGroupUid)

    images_l.value = workcaseDetail.value.ticket.images
    listinfo.value = workcaseDetail.value.ticket.collaterals

    if (workcaseDetail.value.promotionUid !== '0') { 
          retrieveInfo(workcaseDetail.value)
    }

    if (workcaseDetail.value.transactionType !== 'REDEEM') {
      if(workcaseDetail.value.latest){
        calIntInt()
      }
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ปกติ'
      } else if (workcaseDetail.value.status === 'FREEZE') {
        tk_status.value = 'อายัด'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      } else if (workcaseDetail.value.status === 'ACTIVE') {
        tk_status.value = 'กำลังดำเนินการ'
      } else if (workcaseDetail.value.status === 'BREAKING') {
        tk_status.value = 'ของหลุด'
      }

    } else {
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ไถ่ถอน'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      }
    }
    if (images_l.value.length > 0) {
      getTicketImage()
      await nextTick();
      document.getElementById("detailModal").click();
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      await nextTick();
      document.getElementById("detailModal").click();

    }
  }
}


async function getTicketImage() {
  // 🟢 1. เช็กว่าถ้ายังไม่มีการดึงรูปภาพเก็บไว้ในคลัง images.value เลย ถึงจะวิ่งไปโหลด API (ตามลอจิกเดิมของคุณ)
  if (images.value.length === 0) {
    images.value = []
    
    // กรองเอาเฉพาะรายการไฟล์แนบที่มี imageUid จริงๆ (ไม่เป็น "0") มารวมกลุ่มไว้
    const validFiles = images_l.value.filter(file => file.imageUid && file.imageUid !== "0");

    if (validFiles.length > 0) {
      // 🟢 2. วนลูปสร้าง Requests ในรูปแบบ POST Payload ส่งหา Store ส่วนกลาง
      const requests = validFiles.map((fileItem) => {
        const payload = {
          groupUid: shop_detail.value.groupUid, // ส่งค่าว่าง หรือดึงจากตัวแปรกรุ๊ปของหน้านี้ (ถ้ามี)
          shopUid: shop_detail.value.uid,  // ส่งค่าว่าง หรือดึงจากตัวแปรไอดีร้านค้าของหน้านี้ (ถ้ามี)
          uid: String(fileItem.imageUid) // รหัสไอดีของไฟล์แนบชิ้นนั้นๆ
        };
        // เรียกใช้ผ่านฟังก์ชัน store ส่วนกลางที่เราปรับปรุงแก้ไขเรียบร้อยแล้ว [INDEX]
        return storedoc.getFileFetch(payload); // 💡 ตรวจสอบชื่อตัวแปร store ของหน้านี้ให้ตรงนะครับ เช่น storedoc หรือ stored
      });

      try {
        // 🟢 3. เปลี่ยนมาใช้ Promise.all ยิงดาวน์โหลดทุกไฟล์พร้อมกันแบบขนานรวดเดียว [INDEX]
        const allResults = await Promise.all(requests);
        
        if (allResults) {
          for (let i = 0; i < allResults.length; i++) {
            if (allResults[i] && allResults[i].status === 200 && allResults[i].data !== null) {
              const rawData = allResults[i].data;
              const isBlob = rawData instanceof Blob || (rawData && rawData.size !== undefined);
              
              if (isBlob) {
                // สแกนตรวจสอบเนื้อไฟล์จริง (Magic Numbers)
                const textHead = await rawData.slice(0, 4).text();
                let cleanBlob;
                let fileType;

                if (textHead === "%PDF") {
                  cleanBlob = new Blob([rawData], { type: 'application/pdf' });
                  fileType = 'application/pdf';
                } else if (textHead.startsWith("PK")) {
                  cleanBlob = new Blob([rawData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                } else {
                  // 🖼️ สลัดหัวคำสั่งดาวน์โหลดทิ้ง บังคับครอบหัวภาพใหม่ให้สะอาด 100% บนหน้าบ้าน รูปไม่แตก
                  cleanBlob = new Blob([rawData], { type: 'image/jpeg' });
                  fileType = 'image/jpeg';
                }

                const dataUrl = URL.createObjectURL(cleanBlob);
                const originalItem = validFiles[i];

                images.value.push({
                  src: dataUrl,
                  thumbnailImageSrc: dataUrl,
                  alt: '',
                  title: fileType, 
                  filename: 'attachment_' + originalItem.imageUid, 
                  uid: originalItem.uid,
                  imageUid: originalItem.imageUid,
                  rawBlob: cleanBlob 
                });
              }
            }
          }
        }
      } catch (e) {
        console.error("Error in Promise.all getTicketImage:", e);
        return;
      }
    }

    // แผนสำรอง: ถ้าดึงออกมาแล้วไม่มีรูปแนบอยู่จริง ให้ยัดรูปภาพทดแทน (No Image) ตามเงื่อนไขเดิมของคุณ
    if (images.value.length === 0) {
      images.value.push({
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      });
    }
  }

  // 🟢 4. แยกเส้นทางการพรีวิวและดาวน์โหลดในกรณีที่เจอไฟล์ PDF หรือ Excel (หยิบตัวแรกมาตรวจสอบทิศทาง)
  if (images.value.length > 0) {
    const targetFile = images.value[0];
    const fileType = targetFile.title || "";
    const fileSrc = targetFile.src || "";

    if (fileType === 'application/pdf') {
      // 📄 กรณีเป็น PDF -> ดีดเปิดแท็บใหม่ทันที ไม่ค้างป๊อปอัปพัง
      window.open(fileSrc, '_blank');
      return; // ตัดจบตรงนี้ ไม่ให้หลุดไปค้างป๊อปอัปรูปแตกด้านนอก

    } else if (fileType.includes('spreadsheetml') || fileType.includes('excel')) {
      // 📊 กรณีเป็น Excel -> สั่งดาวน์โหลดลงเครื่องทันทีพร้อมชื่อสั้นอ่านง่าย
      let today = moment(new Date()).local().format('YYYYMMDD_HHmmss');
      let fileNameDownload = `excel_${today}.xlsx`;
      
      const link = document.createElement('a');
      link.href = fileSrc;
      link.setAttribute('download', fileNameDownload);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return; // ตัดจบตรงนี้ ไม่ให้หลุดไปเปิด Modal
    }
  }

}

async function getworkCaseInfo(id) {
  let data = "";
  data = {
    uid: id,
  };
  const payload = data;

  const response = await storewc.workCaseinfoFetch(payload);
  // console.log("workCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail.value = response.data.data
      }
    }
  }
}


async function calIntInt() {
  let postponeDate = ''
  if (workcaseDetail.value.postponeCount != 0) {
    postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
  }
  let data = "";
  let pawnValue = 0
  if (workcaseDetail.value.transactionType != 'REDEEM') {
    pawnValue = workcaseDetail.value.newPawnValue
  } else {
    pawnValue = workcaseDetail.value.pawnValue
  }
  let cusUid = workcaseDetail.value.customerInfo.customerUid
    
  if(workcaseDetail.value.represent || workcaseDetail.value.shopRepresent){
      cusUid =  workcaseDetail.value.tkCustomerInfo.customerUid 
  }
  
  data = {
    cusUid: cusUid,
    txType: workcaseDetail.value.transactionType,
    pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    postponeDate: postponeDate,
    pawnValue: pawnValue,
    promotionUid: workcaseDetail.value.promotionUid,
    interestUid: workcaseDetail.value.interestUid,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestCalculateFetch(payload);
  // console.log("calIntInt r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
        int_period.value = res.interestPeriod

      }
    }
  }
}

async function detailPayment(item) {
  // console.log('detailPayment : ' + item);
  let data = "";
  data = {
    uid: item,
  };
  const payload = data;
  const response = await storepm.paymentGroupinfoFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        paymentE.value = response.data.data
        filterPayType()
        // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
      }
    }
  }
}

function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  }
  return side
}

function filterPayType() {
  payment_l.value = []
  let pt = [{ name: 'CASH' },
  { name: 'BANK_TRANSFER' },
  { name: 'CREDIT_CARD' },
  { name: 'CHEQUE' },
  { name: 'PROMPT_PAY_MOBILE' },
  { name: 'PROMPT_PAY_TAX_ID' },
  { name: 'QR_CODE' },
  ]
  let lsum = []
  for (let i = 0; i < pt.length; i++) {
    lsum = filterSumPay(pt[i].name)
    if (lsum.length > 0) {
      payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
    } else {
      payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
    }
  }
}

function filterSumPay(str) {
  let nump = 0, numr = 0, numf = 0
  let lp = paymentE.value.payments.filter((c) => c.type === str);
  if (lp.length > 0) {
    let pay = 0
    let receive = 0
    let fee = 0
    for (let i = 0; i < lp.length; i++) {
      pay = pay + lp[i].pay
      receive = receive + lp[i].receive
      fee = fee + lp[i].feeReceive
      // fee = fee + lp[i].fee
    }
    nump = pay
    numr = receive
    numf = fee
  }
  let lockL = []
  lockL.push({ pay: nump, receive: numr, fee: numf })
  // console.log('lockL : ' + JSON.stringify(lockL));
  return lockL
}

async function getShopInfo() {
  shop_info.value = null
  let data = "";
  data = {
    uid: shop_detail.value.uid,
  };
  const payload = data;
  const response = await storesh.shopInfoFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_info.value = response.data.data
        // console.log('shop_info : ' + JSON.stringify(shop_info.value));
      }
    }
  }
}


async function XlsxGen(item) {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }

  let data = "";
  data = {
    groupUid: shop_info.value.groupUid,
    shopUid: shop_info.value.uid,
    lotUid: item.uid,
    shopInfo: shop_info.value.fullname,
  };
  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/pawn-rpt-svc/breaking/lot/xlsx`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    // console.log('XlsxGen : ' + JSON.stringify(response.headers.get("content-type")));
    let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
    let fileName = item.lotNumber + `_${today}.xlsx`
    const url = URL.createObjectURL(new Blob([response.data], { type: "application/xlsx" }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
  } else {
    swal("โหลด EXCEL ไม่สำเร็จ", "", "error");
  }
}


async function pdfGen(item) {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }
  let data = "";
  data = {
    groupUid: shop_info.value.groupUid,
    shopUid: shop_info.value.uid,
    lotUid: item.uid,
    shopInfo: shop_info.value.fullname,
    catOrder: listcat_order.value
  };
  // console.log('data : ' + JSON.stringify(data));
  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/pawn-rpt-svc/breaking/lot/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  // console.log('pdfGen : ' + JSON.stringify(response.headers.get("content-type")));
  if (response.headers.get("content-type") === 'application/pdf') {

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}

function setlistrc() {
  listrc.value = []
  currentPageRC.value = 1
  totalRowsRC.value = 0
  totalRows_sRC.value = ''
}


function filterStatuslistrc() {
  let process = false
  if (listrc.value.length > 0) {
    let name = listrc.value.filter((c) => c.status === 'ACTIVE');
    if (name.length > 0) {
      process = true
    }
  }
  return process
}

async function checkEstGoldProcess() {
  if (est_detail.value.uid !== '') {
    await updateEstGold()
  } else {
    await addEstGold()
  }
}


async function getEstGoldInfo() {
  est_detail.value = {
    uid: '',
    estimatePrice: 0,
    remark: '',
    version: '',
    lotno: '',
  }
  let data = "";
  data = {
    uid: lurc_search.value,
  };
  const payload = data;
  const response = await storeest.estGoldInfoFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log('estGold : ' + JSON.stringify(response.data));
        if (response.data.data !== null) {
          est_detail.value = response.data.data
        }
        est_detail.value.lotno = lrc_search.value
        document.getElementById("estimateModal").click();
      }
    }
  }
}

async function addEstGold() {
  let data = "";
  data = {
    lotUid: lurc_search.value,
    estimatePrice: est_detail.value.estimatePrice,
    remark: '',
  };
  const payload = data;
  // console.log('addEstGold p : ' + JSON.stringify(payload));
  const response = await storeest.estGoldAddFetch(payload);
  // console.log('addEstGold r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        await loadRecodeListApi()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}


async function updateEstGold() {
  let data = "";
  data = {
    uid: est_detail.value.uid,
    estimatePrice: est_detail.value.estimatePrice,
    remark: '',
    version: est_detail.value.version,
  };
  const payload = data;
  // console.log('updateEstGold p : ' + JSON.stringify(payload));
  const response = await storeest.estGoldUpdateFetch(payload);
  // console.log('updateEstGold r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        await loadRecodeListApi()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function setReturnValue(item) {
  // console.log('setReturnValue : ' + JSON.stringify(item));
  rve_detail.value = {
    uid: item.uid,
    category: [],
    version: item.version,
    pawnValue: item.pawnValue,
    remainAmount: item.remainAmount,
    createDate: item.createDate,
    catUid: item.catUid,
    catName: item.catName,
  }

  if (item.catUid === '0') {
    if (item.catName !== '' && item.catName != null) {
      let ld = listprint.value.filter((c) => c.name === item.catName);
      if (ld.length > 0) {
        rve_detail.value.catUid = ld[0].uid
      }
    } else {
      if (item.category !== '' && item.category != null) {
        const catString = item.category;
        let array1 = catString.split(',');
        for (let i = 0; i < array1.length; i++) {
          let ld = listprint.value.filter((c) => c.name === array1[i]);
          if (ld.length > 0) {
            rve_detail.value.catUid = ld[0].uid
            rve_detail.value.catName = ld[0].name
          }
        }
      }
    }
  }



  // console.log('rve_detail : ' + JSON.stringify(rve_detail.value));
}


function cancelUpdateReturnValue() {
  rve_detail.value = {
    uid: '',
    category: [],
    version: '',
    pawnValue: 0,
    remainAmount: 0,
    createDate: new Date(),
    catUid: '',
    catName: '',
  }

}

async function updateReturnValue() {
  let catuid = ''
  let catname = ''
  if (rve_detail.value.catUid === '') {
    catuid = 0
  } else {
    catuid = rve_detail.value.catUid
    catname = filterCat(rve_detail.value.catUid)
  }
  const payload = {
    uid: rve_detail.value.uid,
    catUid: catuid,
    catName: catname,
    version: rve_detail.value.version
  }

  // console.log("updaterv p : " + JSON.stringify(payload));
  const response = await storelo.updateReturnValueFetch(payload);
  // console.log("updaterv r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        cancelUpdateReturnValue()
        await lotReturnInfo()
        await returnValueList()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}


async function listAllowCat() {
  listallow_cat.value = []
  let data = "";
  data = {
    uid: rv_detail.value.lotUid,
  };
  const payload = data;
  const response = await storelo.listAllowCatFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listallow_cat.value = response.data.data
        // console.log('listallow_cat : ' + JSON.stringify(listallow_cat.value));
      }
    }
  }
}


async function getDepositInfo(tkRef) {
  let data = "";
  data = {
    index: 0,
    size: 1,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    cusUid: '',
    refNumber: '',
    tkRefNumber: tkRef.trim(),
    channel: '',
    txDate: 0,
  };
  const payload = data;
  // console.log("ld p : " + JSON.stringify(payload));
  const response = await storedepo.listDepositFetch(payload);
  // console.log("ld r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list
        dep_ref.value = listd[0].refNumber
      }
    }
  }
}

async function getworkCaseInfoPrv(prevRefNumber) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name
        transdate_prv.value = workcase_prv.workItems[0].startTime 
      }
    }
  }
}


async function getworkCaseImg(item) {
  loading.value = true
  let workcase = null
  images.value = [] // เคลียร์รอรับภาพใหม่

  let data = {
    uid: item.workCaseUid,
  };
  const payload = data;
  const response = await storewc.workCaseinfoFetch(payload);

  if (response && response.status === 200) {
    if (response.data.rtnDesc === "success") {
      workcase = response.data.data;
      
      // ตรวจสอบว่ามีข้อมูลรูปภาพแนบมาใน ticket หรือไม่
      if (workcase && workcase.ticket && workcase.ticket.images && workcase.ticket.images.length > 0) {
        
        // 1. กรองเอาเฉพาะรายการที่มี imageUid จริงๆ (ไม่เป็น "0" และไม่ว่าง) มารวมกลุ่มไว้
        const validFiles = workcase.ticket.images.filter(file => file.imageUid && file.imageUid !== "0" && file.imageUid !== "");

        if (validFiles.length > 0) {
          // 🟢 2. วนลูปสร้าง Requests ในรูปแบบ POST Payload ส่งหา Store ส่วนกลาง
          const requests = validFiles.map((fileItem) => {
            const filePayload = {
              groupUid: shop_detail.value.groupUid, // ส่งค่าว่าง หรือดึงจากตัวแปรกรุ๊ปของหน้านี้ (ถ้ามี)
              shopUid: shop_detail.value.uid,  // ส่งค่าว่าง หรือดึงจากตัวแปรไอดีร้านค้าของหน้านี้ (ถ้ามี)
              uid: String(fileItem.imageUid) // รหัสไอดีของไฟล์แนบ
            };
            // เรียกใช้ผ่าน Store ส่วนกลางที่แก้เป็น POST + Blob ไว้เรียบร้อยแล้ว [INDEX]
            return storedoc.getFileFetch(filePayload); // 💡 ตรวจสอบชื่อตัวแปร store ของหน้านี้ให้ตรงนะครับ เช่น storedoc หรือ stored
          });

          try {
            // 🟢 3. ยิงดาวน์โหลดทุกไฟล์พร้อมกันแบบขนานด้วย Promise.all [INDEX]
            const allResults = await Promise.all(requests);
            
            if (allResults) {
              for (let i = 0; i < allResults.length; i++) {
                if (allResults[i] && allResults[i].status === 200 && allResults[i].data !== null) {
                  const rawData = allResults[i].data;
                  const isBlob = rawData instanceof Blob || (rawData && rawData.size !== undefined);
                  
                  if (isBlob) {
                    // สแกนตรวจสอบเนื้อไฟล์จริง (Magic Numbers)
                    const textHead = await rawData.slice(0, 4).text();
                    let cleanBlob;
                    let fileType;

                    if (textHead === "%PDF") {
                      cleanBlob = new Blob([rawData], { type: 'application/pdf' });
                      fileType = 'application/pdf';
                    } else if (textHead.startsWith("PK")) {
                      cleanBlob = new Blob([rawData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                      fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    } else {
                      // 🖼️ สลัดหัวคำสั่งดาวน์โหลดทิ้ง ครอบหัวภาพใหม่ให้เรนเดอร์ใน Modal ได้สวยงาม ไม่แตก
                      cleanBlob = new Blob([rawData], { type: 'image/jpeg' });
                      fileType = 'image/jpeg';
                    }

                    const dataUrl = URL.createObjectURL(cleanBlob);
                    const originalItem = validFiles[i];

                    images.value.push({
                      src: dataUrl,
                      thumbnailImageSrc: dataUrl,
                      alt: '',
                      title: fileType, 
                      filename: 'attachment_' + originalItem.imageUid, 
                      uid: originalItem.uid,
                      imageUid: originalItem.imageUid,
                      rawBlob: cleanBlob 
                    });
                  }
                }
              }
            }
          } catch (e) {
            console.error("Error inside Promise.all in getworkCaseImg:", e);
            loading.value = false;
            return;
          }
        }
      }

      // 🟢 4. แยกเส้นทางการพรีวิวและดาวน์โหลดตามประเภทไฟล์จริง (หยิบตัวแรกมาตัดสินใจ)
      if (images.value.length > 0) {
        const targetFile = images.value; 
        const fileType = targetFile.title || "";
        const fileSrc = targetFile.src || "";

        if (fileType === 'application/pdf') {
          // 📄 กรณีเป็น PDF -> ดีดเปิดแท็บใหม่ทันที
          loading.value = false;
          window.open(fileSrc, '_blank');

        } else if (fileType.includes('spreadsheetml') || fileType.includes('excel')) {
          // 📊 กรณีเป็น Excel -> สั่งดาวน์โหลดลงเครื่องทันทีพร้อมตั้งชื่อไฟล์ให้อ่านง่าย
          loading.value = false;
          let today = moment(new Date()).local().format('YYYYMMDD_HHmmss');
          let fileNameDownload = `excel_${today}.xlsx`;
          
          const link = document.createElement('a');
          link.href = fileSrc;
          link.setAttribute('download', fileNameDownload);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

        } else {
          // 🖼️ กรณีเป็นรูปภาพปกติ -> เปิดกล่องป๊อปอัป Modal หน้านี้ตามลอจิกเดิมของคุณ
          setGallery2();
          loading.value = false;
          await nextTick();
          document.getElementById("viewGallery").click();
        }

      } else {
        // 🟢 5. แผนสำรอง: กรณีไม่มีรูปแนบอยู่จริง หรือ Uid เป็น "0" ให้สวมภาพ noImg แทนที่ตามดีไซน์เดิมของคุณ
        images.value.push({
          src: noImg,
          thumbnailImageSrc: noImg,
          alt: '',
          title: ''
        });
        setGallery2();
        loading.value = false;
        await nextTick();
        document.getElementById("viewGallery").click();
      }
    }
  } else {
    loading.value = false;
  }
}


function setGallery2() {
  var i, y = "";

  for (i = 0; i < images.value.length; i++) {
    if (i == 0) {
      y = y + '<button type = "button" data-bs-target="#lookupImages2" data-bs-slide-to="' + String(i) + '"' +
        ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
    } else {
      y = y + '<button type = "button" data-bs-target="#lookupImages2" data-bs-slide-to="' + String(i) + '"' +
        ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
    }

  }
  document.getElementById("demo2").innerHTML = y;

}

async function retrieveInfo(item) {
  promotionDetail.value = null
  let data = "";
  let pawnValue = 0
  if (item.transactionType != 'REDEEM') {
      pawnValue = item.newPawnValue
  } else {
      pawnValue = item.pawnValue
  }

  let cusUid = item.customerInfo.customerUid

  if(item.represent || item.shopRepresent){
     cusUid =  item.tkCustomerInfo.customerUid 
  }

  data = {
    cusUid : cusUid,
    pawnDate: moment(item.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    pawnValue: pawnValue,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestRetrieveFetch(payload);
  // console.log("retrieveInfo r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        const result = res.interests.flatMap(item => {
        // เงื่อนไข: เป็นโปรโมชัน และ periodMonths > 1
        if (item.promotion === true && item.periodMonths > 1) {
          // สร้าง Array ใหม่ที่มีจำนวน element เท่ากับ periodMonths และใส่ข้อมูล item ลงไป
          return Array.from({ length: item.periodMonths }, () => ({ ...item }));
        }
        // หากไม่ตรงเงื่อนไข ให้คืนค่าเดิมกลับไป 1 ชุด
        return [item];
        });
        // console.log('result : ' + JSON.stringify(result));
      res.interests  =  result
      promotionDetail.value = res
      // console.log('promotionDetail : ' + JSON.stringify(promotionDetail.value));
      }
    }
  }
}


onMounted(() => {

  if (document.getElementById("second-unitoverhis")) {
    document.getElementById("second-unitoverhis").classList.add('show', 'active')
  }

  if (document.getElementById("secondUnitoverHis")) {
    document.getElementById("secondUnitoverHis").classList.add('show', 'active')
  }

  if (document.getElementById("second-saveunitoverhis")) {
    document.getElementById("second-saveunitoverhis").classList.add('show', 'active')
  }

  if (document.getElementById("secondSaveUnitoverHis")) {
    document.getElementById("secondSaveUnitoverHis").classList.add('show', 'active')
  }

});


</script>

<style lang="scss" scoped>
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

body {
  overflow-y: auto
}
</style>
